export default "__VITE_ASSET__B25dMJby__"